import React, { useState } from 'react';
import './App.css';
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Clients from './components/Clients';
import Footer from './components/Footer';
import { Banner } from './components/Banner';
import { Helmet } from 'react-helmet';

function App() {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <>
      <Helmet>

        <title>Headsup | Bookmark Manager Tool for your Browser</title>
        <meta name="keywords" content="productivity tool, bookmark manager, chrome extension, link organization, context menu bookmarking, efficient workflow, information management, study companion, productivity enhancement"></meta>
          <meta name="description" content="Optimize your workflow with our powerful productivity tool. This Chrome extension serves as a comprehensive bookmark manager, offering context menu-based bookmarking for efficient link organization. Elevate your study experience and boost productivity with this essential work companion."></meta>
          <meta property="og:title" content="Headsup | Bookmark Manager"></meta>
          <meta property="og:description" content="Optimize your workflow with our powerful productivity tool. This Chrome extension serves as a comprehensive bookmark manager, offering context menu-based bookmarking for efficient link organization. Elevate your study experience and boost productivity with this essential work companion."></meta>
          <meta property="og:image" content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"></meta>
          <meta property="og:url" content="https://headsupapp.netlify.app/"></meta>
          <meta name="twitter:card" content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"></meta>
          <meta name="twitter:title" content="Headsup | Bookmark Manager"></meta>
          <meta name="twitter:description" content="Optimize your workflow with our powerful productivity tool. This Chrome extension serves as a comprehensive bookmark manager, offering context menu-based bookmarking for efficient link organization. Elevate your study experience and boost productivity with this essential work companion."></meta>
          <meta name="twitter:image" content="https://res.cloudinary.com/docn0mvoh/image/upload/v1708995003/screenshot-2_rvot5l.png"></meta>
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-Q5E5DTFPJD"></script>

      </Helmet>
      {showBanner && <Banner setShowBanner={setShowBanner} />}
      <Hero />
      <Features />
      <Clients />
      <Pricing />
      <Footer />
    </>

  );
}

export default App;
